import { SpecsPopup as SpecsPopupComponent } from 'swag-client-common/components/popups/specs-popup';
import { connect } from 'react-redux';
import { specsSelector } from '../../../redux/product/product.selectors';
import { specsPopupDispatcher } from '../../../redux/specs-popup/specs-popup.dispatcher';
export const SpecsPopup = connect(specsSelector, specsPopupDispatcher)(SpecsPopupComponent);